import {numberFormat} from "../../../util/numbers.js";
import dayjs from "dayjs";

export const activateChartMouseTracker = elm => {
    elm.addEventListener('mousemove', function (event) {
        const mouseX = event.clientX
        const mouseY = event.clientY
        const diffTracker = document.getElementById('diff-tracker')
        const halfWidth = diffTracker.offsetWidth
        diffTracker.style.position = 'absolute'
        diffTracker.style.left = `${Math.min(Math.max(mouseX - halfWidth + 80, 0), elm.offsetWidth - diffTracker.offsetWidth)}px`
        diffTracker.style.top = `${mouseY - 20}px`
    })
}

export const setOverlay = (context) => {
    const {
        chart: {
            chartArea: {width, left},
            scales,
            tooltip: {
                title,
                dataPoints: [
                    data
                ],
            }
        }
    } = context


    const target = dayjs(title);
    const now = dayjs();

    const diffInDays = now.diff(target, "day");

    const {dataset: {data: [finalValue]}, /*raw: hoverValue */} = data
    // const relativeValueDelta = (finalValue - hoverValue) / (hoverValue || 1)
    const {element: {x, y}} = data
    const finalY = scales.y.getPixelForValue(finalValue)
    const line = document.getElementById('chart-overlay-line')
    // const stroke = finalY > y ? 'red' : 'green'
    // line.style.stroke = stroke
    line.setAttribute('x1', width + left)
    line.setAttribute('y1', finalY)
    line.setAttribute('x2', x)
    line.setAttribute('y2', y)
    const circle = document.getElementById('chart-overlay-circle')
    circle.setAttribute('cx', width + left)
    circle.setAttribute('cy', finalY)
    const text = document.getElementById('chart-overlay-text')
    text.setAttribute('x', (x + width + left) / 2)
    text.setAttribute('y', (y + finalY) / 2)
    // text.innerHTML = `${relativeValueDelta > 0 ? '+' : ''}${numberFormat(relativeValueDelta*100, DECIMAL_FORMAT.FLEX_PERCENTAGE)}%`
    document.getElementById('chart-overlay-days').innerHTML = numberFormat(diffInDays)
}


const DURATION_GROUPS = [
    {
        threshold: 365 * 10,
        label: 'decades',
    },
    {
        threshold: 365,
        label: 'years',
    },
    {
        threshold: 30.5,
        label: 'months',
    },
    // {
    //     threshold: 7,
    //     label: 'weeks',
    // },
    {
        threshold: 1,
        label: 'days',
    },
]


export const getDuration = date => {

    let duration = dayjs().diff(date, "day");
    let durationLabel = 'days'
    let remainder = 0
    let remainderLabel = 'days'

    for (let i = 0; i < DURATION_GROUPS.length - 1; i++) {
        const { threshold, label } = DURATION_GROUPS[i]
        if (duration >= threshold) {
            const { threshold: secondaryThreshold, label: secondaryLabel } = DURATION_GROUPS[i + 1]
            remainder = numberFormat((duration % threshold) / secondaryThreshold, 0)
            duration = Math.floor(duration / threshold, 0)
            remainderLabel = secondaryLabel
            durationLabel = label
            i = DURATION_GROUPS.length
        }
    }
    return {
        duration,
        durationLabel,
        remainder,
        remainderLabel,
    }
}
